import styled from "styled-components"
import { up } from "styled-breakpoints"

const Title = styled.h1`
font-family: 'Open Sans Condensed', sans-serif;
display: table; width: 100%;
   white-space: nowrap;
   font-size:1.2rem;
   line-height: 1.6rem;
   font-weight:700;
text-transform:uppercase;
color:#EB2136;
display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom:10px;

    ${up("md")}{
      font-size:1.8rem;
      line-height: 2.5rem;
}




&:before,
  &:after{
    content:"";
    width: 50%;
    display: block;
  -moz-background-clip: padding-box;
  -webkit-background-clip: padding-box;
  background-clip: padding-box;
  border-bottom:2px dotted #777777;
  
  }
  
`

const Wrapper = styled.span`
    padding:0 20px;
    &:before{
     color:black;
     
    counter-increment: step;                 
  content: "Step " counter(step) ": ";
   }

`

const Heading = ({ children, ...props }) => {
  return <Title {...props}>
    <Wrapper>
      {children}
    </Wrapper>
  </Title>
}
export default Heading
